import {createContext} from 'react'

const EstantesContext = createContext()

export default EstantesContext